<h1>API Health</h1>
Status code: {{ message }}
